<template>
	<div class="welcome">
		<template v-if="type === 1">
			<img :src="resolveAssetsURL(path)" alt="" class="welcome-text">
		</template>
		<template v-else>
			<video :src="resolveAssetsURL(path)" class="welcome-video"></video>
		</template>
	</div>
</template>

<script>
import { resolveAssetsURL } from "@/utils";

export default {
	name: 'Welcome',
	props: {
		type: {
			type: Number,
			default: 1
		},
		path: {
			type: String,
			required: true
		}
	},
	methods: {
		resolveAssetsURL
	}
}
</script>

<style scoped>
.welcome{
	background: url("./texture.png") no-repeat center center / cover;
	width: 100%;
	height: 100%;
	display: flex;
	padding-top: 1.5625rem;
	padding-bottom: 1.5625rem;
	justify-content: center;
	overflow: hidden;
}

.welcome-text{
	height: 100%;
	max-width: 100%;
	object-fit: contain;
	display: block;
}

.welcome-video{
	width: 100%;
	height: 100%;
	object-fit: cover;
}
</style>
